package com.shmbles.web.components

import androidx.compose.runtime.*
import com.shmbles.web.models.Section
import com.shmbles.web.models.Theme
import com.shmbles.web.styles.NavigationItemStyle
import com.shmbles.web.util.Constants.FONT_FAMILY
import com.shmbles.web.util.Res
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*

@Composable
fun OverflowMenu(onMenuClosed: () -> Unit) {
    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    var translateX by remember { mutableStateOf((-100).percent) }
    var opacity by remember { mutableStateOf(0.percent) }

    LaunchedEffect(Unit) {
        translateX = 0.percent
        opacity = 100.percent
    }

    LaunchedEffect(breakpoint) {
        if (breakpoint > Breakpoint.MD) {
            scope.launch {
                translateX = (-100).percent
                opacity = 0.percent
                delay(300)
                onMenuClosed()
            }
        }
    }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(100.vh)
            .styleModifier {
                property("position", "fixed")
                property("top", "0")
                property("left", "0")
                property("z-index", "99999")
            }
            .opacity(opacity)
            .backgroundColor(argb(a = 0.6f, r = 0.0f, g = 0.0f, b = 0.0f))
            .transition(Transition.of(property = "opacity", duration = 300.ms))
            .onClick {
                scope.launch {
                    translateX = (-100).percent
                    opacity = 0.percent
                    delay(300)
                    onMenuClosed()
                }
            }
    ) {
        Column(
            modifier = Modifier
                .fillMaxHeight()
                .padding(all = 30.px)
                .width(if (breakpoint < Breakpoint.MD) 75.percent else 35.percent)
                .styleModifier {
                    property("overflow-y", "auto")
                    property("box-shadow", "4px 0px 20px rgba(0,0,0,0.2)")
                }
                .backgroundColor(Colors.White)
                .translateX(tx = translateX)
                .transition(Transition.of(property = "transform", duration = 300.ms))
                .onClick { it.stopPropagation() }
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .margin(bottom = 35.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                FaXmark(
                    modifier = Modifier
                        .color(Theme.Secondary.rgb)
                        .cursor(Cursor.Pointer)
                        .margin(right = 20.px)
                        .onClick {
                            scope.launch {
                                translateX = (-100).percent
                                opacity = 0.percent
                                delay(300)
                                onMenuClosed()
                            }
                        },
                    size = IconSize.LG
                )
                Image(
                    modifier = Modifier.width(120.px),
                    src = Res.Image.logo,
                    description = "Logo"
                )
            }
            listOf(Section.Home, Section.About, Section.Service, Section.Companies).forEach { section ->
                Link(
                    modifier = NavigationItemStyle.toModifier()
                        .padding(topBottom = 12.px)
                        .margin(bottom = 8.px)
                        .fontFamily(FONT_FAMILY)
                        .fontSize(20.px)
                        .fontWeight(FontWeight.Bold)
                        .color(Theme.Secondary.rgb)
                        .textDecorationLine(TextDecorationLine.None)
                        .onClick {
                            scope.launch {
                                translateX = (-100).percent
                                opacity = 0.percent
                                delay(300)
                                onMenuClosed()
                            }
                        },
                    path = section.path,
                    text = section.title,
                    openInternalLinksStrategy = OpenLinkStrategy.IN_PLACE
                )
            }
        }
    }
}
